var faq = {
    sections: []
};

function parseID(data) {
    var result = [];

    data.forEach(function (unit) {
        result.push(unit.id);

        if (unit.topics && unit.topics.length > 0) {
            unit.topics.forEach(function (topic) {
                result.push(topic.id);
            });
        }
    });

    return result;
}

function validateSections(sections) {
    var ids = parseID(sections);
    var idMap = {};
    var duplicates = [];

    ids.forEach(function (id) {
        if (idMap[id]) {
            duplicates.push(id);
        } else {
            idMap[id] = true;
        }
    });

    if (duplicates.length) {
        console.error("FAQ section data contains duplicate id : " + duplicates);
        return false;
    }

    return true;
}

export default {
    $get: function $get() {
        return {
            getAllSections: function getAllSections() {
                // Return a copy of the data to avoid modifications to the original
                var sections = JSON.parse(JSON.stringify(faq.sections));
                validateSections(sections);
                sections.splice(-1, 1);
                console.log(sections);
                return sections;
            },
            getLinkContent: function getLinkContent(id) {
                var sectionContent = faq.sections.filter(function (section) {
                    return section.id === id;
                }).map(function (section) {
                    return section.title;
                });

                var topicContent = faq.sections.map(function (section) {
                    return section.topics;
                }).reduce(function (flat, item) {
                    return flat.concat(item);
                }, []).filter(function (topic) {
                    return topic.id === id;
                }).map(function (topic) {
                    return topic.inlineQuestion;
                });

                return sectionContent.concat(topicContent)[0];
            }
        };
    },

    setSections: function setSections(sections) {
        faq.sections = sections;
    },

    validateSections: validateSections
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/faq/services/FaqService.js
// module id = 1484
// module chunks = 0